import Demographics from '../pages/Demographics';
import Stores from '../pages/Stores';
import Summary from '../pages/Summary';

/**
 * gets dashboards page component
 * @param {Object} options
 * @param {string} options.path
 * @return {ReactNode}
 */
export const getDashboardsPage = ({ path }) => {
  switch (path) {
    case 'demographics':
      return <Demographics />;
    case 'stores':
      return <Stores />;
    case 'summary':
      return <Summary />;
    default:
      return null;
  }
};
